import { Component, Inject, LOCALE_ID } from '@angular/core';
import { InitialDataService } from 'src/app/services/page/initial-data.service';
import { takeUntil } from 'rxjs/operators';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { CookieService } from 'ngx-cookie-service';
import { HOST_NAME } from 'src/app/global.tokens';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Language } from 'src/app/apollo/models/base-models';
import { FooterComponent } from '../../footer/footer.component';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { HeadManipulateService } from 'src/app/services/utils/head-manipulate.service';
import { providerTrx } from 'src/app/router-translation.labels';
import { environment } from 'src/environments/environment';
import { extractLanguageCode, languageSwitchUrl } from 'src/app/utils/language-switch.utils';

@Component({
  selector: 'app-desktop-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class DesktopFooterComponent extends FooterComponent {
  isReadMore: boolean = true;
  height: any = '145px';

  constructor(
    public initialData: InitialDataService,
    protected location: Location,
    public deviceDetectService: DetectDeviceService,
    protected translationConfig: TranslationConfig,
    protected cookie: CookieService,
    protected router: Router,
    protected manipulateHeaderService: HeadManipulateService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(HOST_NAME) public hostName,
  ) {
    super(
      initialData,
      location,
      deviceDetectService,
      translationConfig,
      cookie,
      manipulateHeaderService,
      locale,
      hostName
    )
  }

  public providerUrl: string = this.translationConfig.getTranslation(providerTrx);

  showMoreTrx = $localize`:@@button-show-more:Read more`;
  showLessTrx = $localize`:@@button-show-less:Read less`;

  childData: any;
  currentUrl: string;
  selectedLanguage: Language;
  homeUrl: string;

  ngOnInit(): void {
    // this.location.onUrlChange((url) => {
    //   let urlArray = url.split('/');
    //   if (urlArray[0].length == 2) {
    //     urlArray = urlArray.slice(1, urlArray.length);
    //   }
    //   this.currentUrl = urlArray.join('/');
    // })
    this.homeUrl = `https://${this.hostName}/${this.locale}/`;
    this.initializeSeoHandlers()

    this.initialData.fetchData().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      this.childData = resp;
      this.selectedLanguage = resp.languages.filter(item => {
         const parts = item.name.split("-"); 
        const langCode = parts[0] === "Lemon" && parts.length > 1 ? parts.slice(1).join().trim() : parts.join('-').trim();
        return langCode.toLowerCase() === this.locale.toLowerCase();
      })[0];
    })

    if(environment.affiliateProgram) {
      this.affiliateUrl = environment.affiliateProgram;
    }
  }

  setCookie($event) {
    const langCode = extractLanguageCode($event?.value);
    if (!langCode) {
      return;
    }
    this.cookie.set('language', langCode, 2592000, '/', this.hostName);
    const url = languageSwitchUrl($event?.value);
    if (url) {
      window.location.href = url;
      return;
    }
    const selected = this.childData?.languages?.find((item) => item?.name === $event?.value);
    if (selected?.redirectUrl) {
      window.location.href = selected.redirectUrl;
    }
  }

  toggleData() {
    this.isReadMore = !this.isReadMore
    if (!this.isReadMore) {
      this.height = '730px'
    } else {
      this.height = '145px'
    }
  }

  public formatBreaks(text: string): string {
    if (!text) return '';

    const words = text.trim().split(/\s+/).filter(Boolean);
    if (!words.length) return '';

    const shouldBreakBefore3 = (words[1]?.length ?? 0) > 4 && words.length >= 3;
    const shouldBreakBefore5 = (words[3]?.length ?? 0) > 4 && words.length >= 5; 
    const out: string[] = [];

    for (let i = 0; i < words.length; i++) {
      const breakNow =
        (i === 2 && shouldBreakBefore3) ||
        (i === 4 && shouldBreakBefore5);

      if (breakNow) out.push(`<span class="br"></span>`);

      const prefix = i > 0 ? '&nbsp;' : '';

      out.push(`<span class="w">${prefix}${this.escapeHtml(words[i])}</span>`);
    }

    return out.join('');
  }



  private escapeHtml(s: string): string {
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


}
